import React, { useContext, useEffect } from 'react';
import SessionContext from 'api/session/context';
import * as IconType from './svg';
import { Typography, colors, Modal, Button } from '@cencosud-ds/bigbang';
import { nameIconType } from './interface';
import styled from '@emotion/styled';
import t from 'utils/translate';
import './style.css';
import { saveSellerLog } from 'api/reputation';
import { NEW, PLANGROWTH } from 'variables/nivele';
interface PropsAccordionName {
  INewReputationSeller: nameIconType | string;
  isOpen: boolean;
  closeModal: () => void;
}

export const dataTextModal = {
  Nuevo: {
    title: t('reputation_components_modal_seller_nivel_new_title'),
    description: t('reputation_components_modal_seller_nivel_new_description'),
  },
  Bajo: {
    title: t('reputation_components_modal_seller_nivel_low_title'),
    description: t('reputation_components_modal_seller_nivel_low_description'),
  },
  Medio: {
    title: t('reputation_components_modal_seller_nivel_half_title'),
    description: t('reputation_components_modal_seller_nivel_half_description'),
  },
  Bueno: {
    title: t('reputation_components_modal_seller_nivel_well_title'),
    description: t('reputation_components_modal_seller_nivel_well_description'),
  },
  Destacado: {
    title: t('reputation_components_modal_seller_nivel_outstanding_title'),
    description: t('reputation_components_modal_seller_nivel_outstanding_description'),
  },
};

export default function ModalLevels({ INewReputationSeller }: PropsAccordionName): JSX.Element {
  const {
    terms,
    auth: { jwt, newReputationSeller },
  } = useContext(SessionContext);
  const firstTimeTour = localStorage.getItem('firstTimeTour');
  const IconStyled = styled(IconType[INewReputationSeller as nameIconType])``;

  const [openModal, setOpenModal] = React.useState(false);
  useEffect(() => {
    if (newReputationSeller.isNewReputation) {
      if (firstTimeTour === '1' && !terms.length) {
        setOpenModal(true);
      }
    }
  }, [firstTimeTour, terms, newReputationSeller]);

  const onClick = () => {
    let memoReputation = newReputationSeller.reputationCategory;
    if ([NEW].includes(newReputationSeller.reputationCategory)) {
      memoReputation = PLANGROWTH;
    }
    saveSellerLog(jwt, { modalShow: newReputationSeller.isNewReputation, reputation: memoReputation });
    setOpenModal(!openModal);
    window.location.reload();
  };

  return (
    <Modal open={openModal} persistent={true} with-blur={false} id="modal-example-reputation" onClose={onClick}>
      <div className="modal__containers">
        <div className="modal__containers--close">
          <Button className="button-exitbutton" darkMode={true} onClick={onClick}>
            <div className="svg-exitbutton">
              <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                  fill-rule="evenodd"
                  clip-rule="evenodd"
                  d="M13.4141 12.5002L17.7071 8.20725C18.0981 7.81625 18.0981 7.18425 17.7071 6.79325C17.3161 6.40225 16.6841 6.40225 16.2931 6.79325L12.0001 11.0862L7.70713 6.79325C7.31613 6.40225 6.68413 6.40225 6.29313 6.79325C5.90213 7.18425 5.90213 7.81625 6.29313 8.20725L10.5861 12.5002L6.29313 16.7933C5.90213 17.1843 5.90213 17.8162 6.29313 18.2072C6.48813 18.4022 6.74413 18.5002 7.00013 18.5002C7.25613 18.5002 7.51213 18.4022 7.70713 18.2072L12.0001 13.9142L16.2931 18.2072C16.4881 18.4022 16.7441 18.5002 17.0001 18.5002C17.2561 18.5002 17.5121 18.4022 17.7071 18.2072C18.0981 17.8162 18.0981 17.1843 17.7071 16.7933L13.4141 12.5002Z"
                  fill="#166DC2"
                />
              </svg>
            </div>
          </Button>
        </div>
        <div className="modal-levels__containers">
          <IconStyled />
          <Typography color={colors.primary[500]} weight={'bold'} typeElement="h4">
            {dataTextModal[INewReputationSeller].title}
          </Typography>
          <Typography color={colors.neutral[400]} weight={'regular'} typeElement="body2">
            {dataTextModal[INewReputationSeller].description}
          </Typography>
        </div>
        <Button className="modal-levels__button" onClick={onClick}>
          {t('reputation_components_modal_seller_nivel_button')}
        </Button>
      </div>
    </Modal>
  );
}
